/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Activity_Avg_Response_TimeInputs */

const en_analytics_activity_avg_response_time = /** @type {(inputs: Analytics_Activity_Avg_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avg. Response Time`)
};

const de_analytics_activity_avg_response_time = /** @type {(inputs: Analytics_Activity_Avg_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchschn. Antwortzeit`)
};

const fr_analytics_activity_avg_response_time = /** @type {(inputs: Analytics_Activity_Avg_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps de réponse moyen`)
};

const es_analytics_activity_avg_response_time = /** @type {(inputs: Analytics_Activity_Avg_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo de respuesta promedio`)
};

const it_analytics_activity_avg_response_time = /** @type {(inputs: Analytics_Activity_Avg_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo medio di risposta`)
};

const nl_analytics_activity_avg_response_time = /** @type {(inputs: Analytics_Activity_Avg_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gem. reactietijd`)
};

const pl_analytics_activity_avg_response_time = /** @type {(inputs: Analytics_Activity_Avg_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śr. czas odpowiedzi`)
};

const fi_analytics_activity_avg_response_time = /** @type {(inputs: Analytics_Activity_Avg_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keskim. vasteaika`)
};

const da_analytics_activity_avg_response_time = /** @type {(inputs: Analytics_Activity_Avg_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gns. svartid`)
};

const sv_analytics_activity_avg_response_time = /** @type {(inputs: Analytics_Activity_Avg_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gns. svarstid`)
};

/**
* | output |
* | --- |
* | "Avg. Response Time" |
*
* @param {Analytics_Activity_Avg_Response_TimeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_activity_avg_response_time = /** @type {((inputs?: Analytics_Activity_Avg_Response_TimeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Activity_Avg_Response_TimeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_activity_avg_response_time(inputs)
	if (locale === "fr") return fr_analytics_activity_avg_response_time(inputs)
	if (locale === "es") return es_analytics_activity_avg_response_time(inputs)
	if (locale === "it") return it_analytics_activity_avg_response_time(inputs)
	if (locale === "nl") return nl_analytics_activity_avg_response_time(inputs)
	if (locale === "pl") return pl_analytics_activity_avg_response_time(inputs)
	if (locale === "fi") return fi_analytics_activity_avg_response_time(inputs)
	if (locale === "da") return da_analytics_activity_avg_response_time(inputs)
	if (locale === "sv") return sv_analytics_activity_avg_response_time(inputs)
	return en_analytics_activity_avg_response_time(inputs)
});